export const persistGeo = async ({ persistedInfo, checkCPAndSetZones, setCpParams }) => {
  const urlString = window.location.href;
  const url = new URL(urlString);
  const zone = url.searchParams.get("zone");

  if (zone && (zone === "ZL" || zone === "ZR")) {
    switch (zone) {
      case "ZR":
        const infoRegulada = await (import('./regulada_zone.json'));
        setCpParams(infoRegulada);
      break;
      case "ZL":
      default:
        setCpParams({ cp: "28030", zone: "ZL", municipio: "", businessZones: [], persist: true });
      break;
    }
  } else if (persistedInfo && persistedInfo.geo && persistedInfo.geo.postalCode) {
    const {
      geo: { postalCode = "28030", zone = "ZL", municipio = "", businessZones = [] },
    } = persistedInfo;

    const geo = { cp: postalCode, zone, municipio, businessZones };
    setCpParams(geo);
  } else {
    checkCPAndSetZones({ cp: "" });
  }
};

export default persistGeo;
